export const RANGE_OPTIONS = [
  {
    label: '+5 km',
    value: 5
  },
  {
    label: '+10 km',
    value: 10
  },
  {
    label: '+15 km',
    value: 15
  },
  {
    label: '+20 km',
    value: 20
  },
  {
    label: '+25 km',
    value: 25
  },
  {
    label: '+50 km',
    value: 50
  },
  {
    label: '+75 km',
    value: 75
  },
  {
    label: '+100 km',
    value: 100
  },
  {
    label: '+150 km',
    value: 150
  },
  {
    label: '+200 km',
    value: 200
  }
];

export const ALERT_FREQUENCIES = [{
  label: 'jobAlert.daily',
  value: 'daily'
}, {
  label: 'jobAlert.weekly',
  value: 'weekly'
}, {
  label: 'jobAlert.monthly',
  value: 'monthly'
}];
